export default __webpack_public_path__ + "23a5e5c107f1f218d905b7adbc1c579e.png";